import { AlphaXCircleIcon } from './AlphaXCircleIcon';

/**
 * author: Contributors
 * id BF0C5599-EFCE-44ED-AD08-3CE99DFC9802
 * name alpha-x-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-x-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetXCircleIcon = AlphaXCircleIcon;
export default AlphabetXCircleIcon